import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ChatFAB from "../ai/ChatFAB";
import SosFAB from "../emergency/SosFAB";

const Layout = ({ children }) => (
    <div className="flex min-h-screen flex-col bg-white dark:bg-zinc-950">
        <Navbar />
        <main className="flex-1" data-testid="site-main">{children}</main>
        <Footer />
        {/* v3A — global AI assistant FAB (auto-hides on /chat and admin/business pages) */}
        <ChatFAB />
        {/* v3E.3 — global Emergency SOS FAB */}
        <SosFAB />
    </div>
);

export default Layout;
